import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { EventService } from 'src/app/event.service';
import { SnackbarService } from 'src/app/snackbar.service';
import { ValidationService } from 'src/app/validation.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '../storage.service';

@Component({
  selector: 'app-dashboard-settings',
  templateUrl: './dashboard-settings.component.html',
  styleUrls: ['./dashboard-settings.component.scss']
})
export class DashboardSettingsComponent implements OnInit {

  showLoader = false;

  defaultData: any = {
    count: '',
    type: 'hours'
  };
  deadline_expiry: any = {
    count: '',
    type: 'hours'
  };

  shipment_acceptance:any = {
     count:'', 
     type:'hours'
  }
  shipment_pending:any = {
     count:'',
     type:'hours'
  }
  shipment_fulfilled:any ={
     count:'',
     type:'hours'
  }
  outstanding_epods:any = { 
    count:'', 
    type:'hours'
  }

  ongoing_shipment: any = {
    count: '',
    type: 'hours'
  };

  operations_status: any = {
    count: '',
    type: 'hours'
  };

  top_shippers: any = {
    count: '',
    type: 'hours'
  };

  carrier: any = '';
  carrier_unit: any;
  carrierId: Subscription;

  selectOptions = [ 'hours', 'days', 'weeks', 'months', 'years' ];

  helpData = [
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];

  constructor(private http: HttpService, private events: EventService, private snackbar: SnackbarService,
              private valid: ValidationService, private translation: TranslateService,
              private storage: StorageService) { }

  ngOnInit() {
    this.getDetails();
    const carriers = JSON.parse(this.storage.getFromLocalStorage('carriers'));
    this.carrier_unit = carriers[0].parent_name + ' - ' + carriers[0].name;
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getDetails();
        const selectedCarrier = carriers.filter((carrier) => {
          if(carrier){
            return carrier._id === data.carrier_id;
          }
        });
        this.carrier_unit = selectedCarrier[0].parent_name + ' - ' + selectedCarrier[0].name;
      }
    );
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getDetails();
      },
      (err: any) => {
        console.log('Err ::', err);
      }
    );
  }

  getDetails() {
    this.showLoader = true;
    this.http.get('constants').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.showLoader = false;
          if (data.data != null) {
            this.carrier = (data.data.carrier) ? data.data.carrier.name || 'N/A' : 'N/A';
            if (data.data.stats_settings) {
              this.deadline_expiry = data.data.stats_settings.deadline_expiry || this.defaultData;
              this.shipment_acceptance = data.data.stats_settings.shipment_acceptance || this.defaultData;
              this.shipment_pending = data.data.stats_settings.shipment_pending || this.defaultData;
              this.shipment_fulfilled = data.data.stats_settings.shipment_fulfilled || this.defaultData;
              this.outstanding_epods = data.data.stats_settings.outstanding_epods || this.defaultData;
              this.ongoing_shipment = data.data.stats_settings.ongoing_shipment || this.defaultData;
              this.operations_status = data.data.stats_settings.operations_status || this.defaultData;
              this.top_shippers = data.data.stats_settings.top_shippers || this.defaultData;
            }

            (this.deadline_expiry.type == 'hrs') ? this.deadline_expiry.type = 'hours' : '';
            (this.shipment_acceptance.type == 'hrs') ? this.shipment_acceptance.type = 'hours' : '';
            (this.shipment_pending.type == 'hrs') ? this.shipment_pending.type = 'hours' : '';
            (this.shipment_fulfilled.type == 'hrs') ? this.shipment_fulfilled.type = 'hours' : '';
            (this.outstanding_epods.type == 'hrs') ? this.outstanding_epods.type = 'hours' : '';
            (this.ongoing_shipment.type == 'hrs') ? this.ongoing_shipment.type = 'hours' : '';
            (this.operations_status.type == 'hrs') ? this.operations_status.type = 'hours' : '';
            (this.top_shippers.type == 'hrs') ? this.top_shippers.type = 'hours' : '';
          }
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  submit(ind, value) {
    if (!value.count) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.DASHBOARD_SETTINGS.VALIDATION.COUNT'), '', 'err');
      return false;
    } else if ( !value.type) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.DASHBOARD_SETTINGS.VALIDATION.UNIT'), '', 'err');
      return false;
    }
    if(value.count && value.count < 0){
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.DASHBOARD_SETTINGS.VALIDATION.INVALID'), '', 'err');
      return false;
    }
    this.showLoader = true;

    const dataToSend: any = {};
    switch (ind) {
      case 1:
        dataToSend.deadline_expiry = {
          count: value.count,
          type: (value.type == 'hours') ? 'hrs' : value.type,
        };
        break;
      case 2:
        dataToSend.shipment_pending = {
          count: value.count,
          type: (value.type == 'hours') ? 'hrs' : value.type,
        };
        break;
      case 3:
        dataToSend.shipment_acceptance = {
          count: value.count,
          type: (value.type == 'hours') ? 'hrs' : value.type,
        };
        break;
      case 4:
        dataToSend.ongoing_shipment = {
          count: value.count,
          type: (value.type == 'hours') ? 'hrs' : value.type,
        };
        break;
      case 5:
        dataToSend.outstanding_epods = {
          count: value.count,
          type: (value.type == 'hours') ? 'hrs' : value.type,
        };
        break;
      case 6:
        dataToSend.shipment_fulfilled = {
          count: value.count,
          type: (value.type == 'hours') ? 'hrs' : value.type,
        };
        break;
      case 7:
        dataToSend.operations_status = {
          count: value.count,
          type: (value.type == 'hours') ? 'hrs' : value.type,
        };
        break;
      case 8:
        dataToSend.top_shippers = {
          count: value.count,
          type: (value.type == 'hours') ? 'hrs' : value.type,
        };
      break;
    }

    this.http.post('settings/stats_constants', dataToSend).subscribe(
      (resp: any) => {
        if (resp.statusCode === 200) {
          this.showLoader = false;
          this.getDetails();
          this.snackbar.openSnackBar(this.translation.instant('MESSAGE.DASHBOARD_SETTINGS.SUCCESS.UPDATE'), '');
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
   }
}

